import { fetchAPI } from './fetchAPI';

export const signOut = async () => {
  return await fetchAPI('auth', { method: 'DELETE' });
};
